import React from 'react';

function EmptyState({ icon, title, subtitle }) {
  return (
    <div style={{
      textAlign: 'center',
      padding: '48px 24px',
      color: 'var(--text-secondary)',
    }}>
      {icon && <div style={{ fontSize: '2.2rem', marginBottom: 12, opacity: 0.5 }}>{icon}</div>}
      {title && <div style={{ fontSize: '0.95rem', fontWeight: 600, marginBottom: 6, color: 'var(--text-primary)', opacity: 0.7 }}>{title}</div>}
      {subtitle && <div style={{ fontSize: '0.82rem', lineHeight: 1.5 }}>{subtitle}</div>}
    </div>
  );
}

export default EmptyState;
